import {
  GetBalanceResponse,
  RedeemResponse,
  VoidResponse,
} from './src/service-plugins-types.js';
import {
  GetBalanceEnvelope,
  RedeemEnvelope,
  _voidEnvelope,
} from './src/interfaces-ecom-v1-gift-card-provider-entity.public.js';

export * from './src/service-plugins-error-classes';
export * from './src/service-plugins-types';
export { GetBalanceEnvelope, RedeemEnvelope, _voidEnvelope };

/**
 * This method retrieves gift card data from your app.
 * Wix calls this method when a customer applies a gift card as a payment method at checkout.
 * @throws GiftCardNotFoundWixError
 * @throws GiftCardDisabledWixError
 * @throws GiftCardExpiredWixError
 * @throws MissingCurrencyWixError
 */
export declare function getBalance(
  payload: GetBalanceEnvelope
): GetBalanceResponse | Promise<GetBalanceResponse>;
/**
 * This method requests that a transaction be created by your app.
 * Wix calls this method when a customer completes a purchase that includes a gift card as a payment method at checkout.
 * @throws GiftCardNotFoundWixError
 * @throws GiftCardDisabledWixError
 * @throws GiftCardExpiredWixError
 * @throws InsufficientFundsWixError
 * @throws AlreadyRedeemedWixError
 * @throws CurrencyNotSupportedWixError
 * @throws MissingCurrencyWixError
 */
export declare function redeem(
  payload: RedeemEnvelope
): RedeemResponse | Promise<RedeemResponse>;
/**
 * This method requests that a gift card transaction be voided by your app.
 * Wix calls this method when a purchase fails after gift card redemption.
 */
export declare function _void(
  payload: _voidEnvelope
): VoidResponse | Promise<VoidResponse>;
